import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface AgentEditorViewProps {
	mode: ControlMode;
	label?: string;
	agentsRequest: DropdownRequest<AgentSummary>;
	value: number | null;
	onChanged: (number: AgentSummary) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	buttonAdd?: any
}

@observer
export class AgentEditorView extends React.Component<AgentEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Agent';
		}

		return (
			<div className='filter-panel'>
				<DropdownView
					onGetErrorMessage={this.props.onGetErrorMessage}
					label={label}
					model={this.props.value}
					disabled={this.props.mode == 'display'}
					required={this.props.required}
					onChanged={(item) => { this.props.onChanged(item) }}
					request={this.props.agentsRequest}
					keyField="id"
					textField="name"
					placeholder="Select an Agent"
				/>
				<div style={{ display: 'inline-flex', alignItems: 'flex-end', marginBottom: '6px' }} >
					{this.props.children}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/parts/agent-editor.view.tsx